import * as React from "react";
import { Col, Row, Container } from "react-grid-system";
import styled from "styled-components";
import colors from "../../assets/colors/colors";
import NumberFormat from "react-number-format";
import { MdPlaylistAdd, MdPostAdd, MdInfoOutline } from "react-icons/md";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { StyledColor } from '../../interface/index'

interface Props {
  data: {
    image: string;
    name: string;
    description: string;
    price: string;
    amount: string;
  };
  type: string;
  handleAddItem: (data: any) => void;
  show_order: boolean;
  openModalInfo?: (data: any) => void;
}

export interface StyledColor {
  color: any;
  type: string;
  image: string;
}

export default function Card(props: Props) {
  const [optionOrder, setOptionOrden] = React.useState<boolean>(false);

  const { name, image, price, description, amount } = props.data;

  const openModalInfo = () => {
    props.openModalInfo && props.openModalInfo(props.data);
  };

  return (
    <Container>
      {name && (
        <ContentCard
          color={colors}
          type={props.type}
          image={image}
          onClick={() => openModalInfo()}
        >
          <Row align="center" justify="center">
            {image && (
              <Col xs={4}>
                <div className="contentImage">
                  <LazyLoadImage
                    src={
                      image ||
                      "https://i.postimg.cc/PrdVR20x/placeholder-image.png"
                    }
                  />
                  {/* <img src={image} alt="" /> */}
                </div>
              </Col>
            )}
            <Col xs={image ? 8 : 12}>
              <div className="description">
                <h5 className="card-title">{name || "Sin nombre"}</h5>
                {props.type === "vertical" && (
                  <>{description && <p>{description || ""}.</p>}</>
                )}
                {amount && <p>Cantidad: {amount} </p>}
                <p className="text-primary pricing">
                  RD$
                  <NumberFormat
                    thousandsGroupStyle="thousand"
                    value={price || "0.0"}
                    prefix=""
                    decimalSeparator="."
                    displayType="text"
                    type="text"
                    thousandSeparator={true}
                    allowNegative={true}
                  />
                </p>
              </div>
            </Col>
          </Row>
          {props.show_order && (
            <>
              {optionOrder && (
                <ButtonAdd onClick={() => props.handleAddItem(props.data)}>
                  <span>
                    <MdPostAdd />
                  </span>
                </ButtonAdd>
              )}
            </>
          )}
        </ContentCard>
      )}
    </Container>
  );
}

const ButtonAdd = styled.div`
  width: 10%;
  height: 100%;
  padding: 1em;
  position: absolute;
  bottom: 0;
  right: 0;
  text-align: Center;
  background: #ffffff94;
  font-size: 1.6em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: Center;
  border: 1px solid #2ecc70b9;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  span {
    border-radius: 100px;
  }
  svg {
    color: #2ecc70b9;
  }
`;
const ContentCard = styled.div<StyledColor>`
  box-shadow: none;
  position: relative;
  width: 100%;
  background: white;
  white-space: ${(props) =>
    props.type === "vertical" ? "normal" : "pre-wrap"};
  margin: 1em 0;
  border-bottom: 2px solid #ecf0f1;
  .contentImage {
    margin: 1em auto;
    padding: 0 0.5em;
  }
  img {
    width: 100%;
    height: 100px;
    object-fit: cover;
    border-radius: 1em;
  }
  p {
    margin: 0;
    font-size: 0.8em;
    font-weight: 400;
  }
  h5 {
    font-weight: 500;
    margin: 0;
    color: ${(props) => props.color.black};
  }
  .description {
    padding: ${(props) => (props.image ? "" : "0.5em 1em")};
  }
  @media only screen and (min-width: 768px) {
    img {
      height: 100px !important;
    }
  }
  .pricing {
    font-size: 1em;
    font-weight: bold;
  }
`;
